// @flow
import * as React from 'react'
import { Link } from 'react-router-dom'
import Checkbox from 'ui/atoms/Checkbox'
import FlexBox from 'ui/atoms/FlexBox'
import ListItem from 'ui/atoms/ListItem'
import Text from 'ui/atoms/Text'

import FormControls from './FormControls'

type Props = {
  asLink: boolean,
  controlsDisabled?: boolean,
  enabled?: boolean,
  handleItemClick?: (item: any) => void,
  handleSelectForm: (formId: string) => void,
  id: string,
  isSelected: boolean,
  isPacket: boolean,
  item: any,
  name: string,
  onPublicFormClick: () => void,
  tabletMode?: boolean,
  type?: 'form' | 'pdf' | 'packet',
  setLoading: (loading: boolean) => void,
  isInternalForm: boolean,
  measuresEnabled?: boolean,
}

function FormItem({
  asLink,
  controlsDisabled,
  enabled = true,
  handleItemClick,
  handleSelectForm,
  id,
  isPacket,
  item,
  isSelected,
  name,
  onPublicFormClick,
  tabletMode,
  type,
  setLoading,
  isInternalForm,
  measuresEnabled,
}: Props): React.Node {
  const getResourceLink = React.useCallback(() => {
    if (type === 'form') {
      return `/forms/${id}`
    }

    if (type === 'pdf') {
      return `/pdf/${id}/edit`
    }
  }, [id, type])

  const handleClick = React.useCallback(() => {
    if (tabletMode) {
      return handleSelectForm(id)
    }

    if (handleItemClick) return handleItemClick(item)
  }, [handleItemClick, handleSelectForm, id, item, tabletMode])

  return (
    <ListItem
      $compact={tabletMode}
      as={tabletMode || !asLink ? null : Link}
      onClick={handleClick}
      to={getResourceLink()}
    >
      {tabletMode && <Checkbox checked={isSelected} className="mx-2" />}
      <FlexBox selfCenter>
        <Text $medium $small $muted={!enabled}>
          {name}
        </Text>
      </FlexBox>

      {!tabletMode && (
        <FormControls
          controlsDisabled={controlsDisabled}
          enabled={enabled}
          id={id}
          isInternalForm={isInternalForm}
          isPacket={isPacket}
          measuresEnabled={measuresEnabled}
          onPublicFormClick={onPublicFormClick}
          setLoading={setLoading}
          type={type}
        />
      )}
    </ListItem>
  )
}

export default FormItem
